import React, {useEffect, useRef, useState} from 'react'
import {Calendar} from "react-feather";
import {Select} from "@/Components/Form";
// import DatePicker from "react-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";

export function DateInput({
    setDate,
    selectedDate,
    disableDay = false,
    allowPast= false
  }) {

  const isInitialMount = useRef(true);
  const calendarRef = useRef();
  const currentYear = new Date().getFullYear();

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  let [isCalendarOpen, setIsCalendarOpen] = useState(false);
  let [datePartials, setDatePartials] = useState(
    selectedDate ? {
        year: selectedDate.getFullYear(),
        month: selectedDate.getMonth(),
        day: disableDay ? 1 : selectedDate.getDate()
      }
      : {
        year: "",
        month: "",
        day: disableDay ? 1 : ""
      }
  );

  useEffect(() => {

    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {

      if (datePartials.year !== "" && datePartials.month !== "" && datePartials.day !== "") {
        setDate(new Date(datePartials.year, datePartials.month, datePartials.day, 12))
      }

    }

    if (isCalendarOpen && calendarRef.current) {
      calendarRef.current.input.click();
    }

    const checkIfClickedOutside = e => {
      if (
        isCalendarOpen && calendarRef.current && !calendarRef.current.input.contains(e.target)
      ) {
        setIsCalendarOpen(false)
      }
    }

    document.addEventListener("mousedown", checkIfClickedOutside)

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }

  }, [isCalendarOpen, datePartials]);

  function handleDatePartialUpdate(event) {

    let key = event.target.name;
    let value = event.target.value;

    if (!value.match(/^\d+$/)) {
      return;
    }

    value = parseInt(value);

    if (datePartials.month && key === 'day') {
      const year = datePartials.year || currentYear;
      const daysInMonth = new Date(year, datePartials.month + 1, 0).getDate();

      if (value > daysInMonth) {
        value = daysInMonth;
      }
    }

    setDatePartials( prevValues => {
      return { ...prevValues,[key]: value}
    })
  }

  let endDateSelectFields = {
    years: [],
    months: [],
    days: []
  }

  if(allowPast) {
    for (let i = 0; i < 15; i++) {
      endDateSelectFields.years.push({value: (currentYear - 10) + i, label: (currentYear - 10) + i});
    }
  } else {
    for (let i = 0; i < 10; i++) {
      endDateSelectFields.years.push({value: currentYear + i, label: currentYear + i});
    }
  }

  for (let i = 0; i < 12; i++) {
    endDateSelectFields.months.push({value: i, label: months[i]});
  }

  for (let i = 1; i <= 31; i++) {
    endDateSelectFields.days.push({value: i, label: i});
  }

  return (
    <div className="relative">
      <div className="flex relative z-[5]">

        <div
          className="cursor-pointer p-2 -ml-2 flex items-center justify-center relative before:transition before:ease-in-out before:rounded-full before:w-full before:h-0 before:pb-[100%] before:absolute before:bg-transparent hover:before:bg-primary-light"
          onClick={() => setIsCalendarOpen(!isCalendarOpen)}
        >
          <Calendar size={18} className="relative z-[5] pointer-events-none" />
        </div>

        <Select
          options={endDateSelectFields.years}
          defaultOption="Year"
          name="year"
          className="mr-1 w-28"
          value={datePartials.year}
          onChange={e => handleDatePartialUpdate(e)}
        />

        <Select
          options={endDateSelectFields.months}
          defaultOption="Month"
          name="month"
          className="mr-1 w-28"
          value={datePartials.month}
          onChange={e => handleDatePartialUpdate(e)}
        />

        {!disableDay && (
          <Select
            options={endDateSelectFields.days}
            defaultOption="Day"
            name="day"
            className="mr-1 w-28"
            value={datePartials.day}
            onChange={e => handleDatePartialUpdate(e)}
          />
        )}

      </div>

      <div className="absolute top-0 w-full text-transparent left-8">
        <DatePicker
          ref={calendarRef}
          className="bg-transparent border-0"
          dateFormat="yyyy-MM-dd"
          selected={selectedDate}
          onChange={(date) => {

            if (disableDay) {
              date.setDate(1)
            }

            setDatePartials({
              'year': date.getFullYear(),
              'month': date.getMonth(),
              'day': date.getDate()
            });

            setDate(date);
          }}
        />
      </div>
    </div>
  )
}
